/**
 * 파일 사이즈 bytes → 사람이 읽기 좋은 문자열.
 * - null/undefined → '—' (placeholder)
 * - < 1024 → "{n} B"
 * - < 1MiB  → "{n} KB" (1024 KiB 반올림 정수, tabular-nums 정렬용)
 * - else    → "{n.n} MB" (1 decimal)
 *
 * eng-review D6 — shared/lib/file에 정착. plan §3 정합.
 * 단위: 1 KB = 1024 B (KiB 관습 표기, macOS Finder의 1000 SI와 다름).
 *
 * 다른 callers(MessageItem, entities/proof) 통합은 별 PR (scope 한정).
 */
export function formatFileSize(bytes: number | null | undefined): string {
  if (bytes == null || Number.isNaN(bytes) || bytes < 0) return '—';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
